module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#EBECF1",
      "height": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('section', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Gestiona las operaciones y roles de los usuarios de la institución.")]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "nav"
    }
  }, [_c('ul', _vm._l((_vm.userRol), function(route, index) {
    return _c('router-link', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index !== 0),
        expression: "index !== 0"
      }],
      key: route.path,
      staticClass: "pageLink",
      attrs: {
        "to": route.enlaceWeb,
        "tag": "li"
      }
    }, [_c('a', {
      staticClass: "icon",
      class: route.icono
    }, [_c('span', [_vm._v(_vm._s(route.descripcion))])])])
  }), 1)])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    attrs: {
      "id": "logo"
    }
  }, [_c('a', {
    staticClass: "titulo"
  }, [_vm._v("Mantenimiento de Usuarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "row aln-center p-l-40 p-r-40"
  }, [_c('div', {
    staticClass: "col-4 col-6-medium col-12-small"
  }, [_c('section', [_c('a', {
    staticClass: "image featured",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/inicio.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Con nuestro nuevo sistema brinda mantenimiento a los usuarios del "), _c('a', {
    attrs: {
      "href": "https://www.tc.gob.pe",
      "target": "_blank"
    }
  }, [_vm._v("TRIBUNAL CONSTITUCIONAL")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53500e09"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Inicio.vue
// module id = 338
// module chunks = 1